module.exports = __webpack_public_path__ + "static/media/logo-plane.071a3fb5.png";